import { tokenAxios } from "@/utils/axios";
import { useQuery } from "@tanstack/react-query";
import { TaoGenusArgs } from "@/types/tao-routing";
import { useAppState } from "@/contexts/app-state";
import { buildApiUrl } from "@/utils/api";

const getTaoGenuses = async (params: TaoGenusArgs) => {
  // @eslint-disable-line
  const { data } = await tokenAxios().get<string[]>(buildApiUrl("taoGenuses"), { params });
  return data;
};

export const useTaoGenuses = () => {
  const { context, loggedInUser } = useAppState();
  const practiceId = context?.athena?.practiceId ?? "8967";
  const requestedUser = loggedInUser;

  return useQuery<string[], Error>({
    queryKey: ["Tao-Routing-Genus", practiceId, requestedUser],
    queryFn: () => getTaoGenuses({ practiceId, requestedUser }),
  });
};
